<template>
	<v-app>
		<v-main class="login">
			<v-container class="fill-height" fluid>
				<v-row align="center" justify="center">
					<v-col cols="12" sm="8" md="4">
						<v-card class="elevation-12">
							<v-toolbar color="primary" dark flat>
								<v-toolbar-title class="text-capitalize">login warehouse</v-toolbar-title>
								<v-spacer></v-spacer>
							</v-toolbar>
							<v-card-text>
								<v-form ref="formLogin" role="form" v-on:submit.prevent="onLogin">
									<v-alert dense color="red lighten-1" class="white--text" dismissible v-for="alert in this.alerts" :key="alert.id"> {{alert.message}} </v-alert>
									<v-text-field required :rules="usernameRules" @focus="() => fieldErrors.username=''" :error-messages="fieldErrors.username" placeholder="Username" name="login" prepend-icon="mdi-account" type="text" v-model="username" single-line></v-text-field>
									<v-text-field required :rules="passwordRules" @focus="() => fieldErrors.password=''" :error-messages="fieldErrors.password" id="password" placeholder="Kata Sandi" name="password" prepend-icon="mdi-lock" type="password" v-model="password" :append-icon="iconPass" @click:append="showPassword" single-line></v-text-field>
									<v-layout column align-end class="pt-5">
										<v-flex>
											<v-btn :disabled="isAttempting" color="primary" type="submit">Login</v-btn>
										</v-flex>
									</v-layout>
								</v-form>
							</v-card-text>
						</v-card>
					</v-col>
				</v-row>
			</v-container>
		</v-main>
	</v-app>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapState, mapMutations, mapActions } = createNamespacedHelpers('auth');

export default {
	data() {
		return {
			username: '',
			password: '',
			iconPass: 'mdi-eye',
			passwordRules: [
			v => !!v || 'Kata Sandi tidak boleh kosong',
			],
		}
	},
	props: {
		source: String,
	},
	computed: {
		...mapState(['isAttempting', 'fieldErrors', 'alerts']),
	},
	methods: {
		...mapMutations(['removeAlert', 'reset']),
		...mapActions(['login']),

		onLogin() {
			if	(this.$refs.formLogin.validate())
			{
				this.login({ username: this.username, password: this.password }).then(() => {
					const { redirect } = this.$route.query;

					if (redirect) {
						this.$router.push(redirect);
					} else {
						this.$router.push({ name: "dashboard" })
					}
				});
			}
		},
		showPassword() {
			var x = document.getElementById("password");
			if (x.type === "password") {
				x.type = "text"
				this.sPassword = true
				this.iconPass = 'mdi-eye-off'
			} else {
				x.type = "password"
				this.sPassword = false
				this.iconPass = 'mdi-eye'
			}
		},
	},
	created(){
		this.$store.dispatch('setPageTitle', `Login Warehouse`)
	}
}
</script>